import { gql } from "@apollo/client";

export const CreateUserMutation = gql`
  mutation CreateUser($user: ExtendedUserInput!, $region: AWSRegions!) {
    createUser(user: $user, region: $region) {
      #            authMethod
      email
      firstName
      lastName
      username
    }
  }
`;
